import React from 'react';
import PropTypes from 'prop-types';
import '../styles/hcHomepageStyles.css';

export const PageDescriptor = (props) => {
    return (
        <div className="homePageDescription">
            {props.pageDescription}
            <a href={props.helpURL} target="__blank">{props.clickText}</a>       
        </div>
    ); 
};

PageDescriptor.defaultProps = {
    pageDescription: 'Page description goes here',
    clickText: '',
};

PageDescriptor.propTypes = {
    pageDescription: PropTypes.string,
    clickText: PropTypes.string,
    helpURL: PropTypes.string.isRequired,
};

export default PageDescriptor; 



// WEBPACK FOOTER //
// ./src/components/PageDescriptor.jsx